import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { DeterminantControllerService } from "../../../services/registration-controller/determinant-controller.service";
import { ComponentActionControllerService } from "../../../services/form-controller/component-action-controller.service";
import { BotControllerService } from "../../../services/role-controller/bot-controller.service";
import { ActivatedRoute } from "@angular/router";
import { ActionRow } from "../../../models/action-row";
import { Bot } from "../../../models/bot";
import { ComponentAction } from "../../../models/component-action";
import * as _ from "lodash";

@Component({
  selector: "determinant-triggers-action",
  templateUrl: "./determinant-triggers-action.component.html",
  providers: [DeterminantControllerService, BotControllerService, ComponentActionControllerService],
})
export class DeterminantTriggersActionComponent implements OnInit {

  @Input() public showHeader: boolean = false;
  @Input() public actions: ActionRow[] = [];
  @Input() public fieldId: string;
  @Input() public serviceId: string;
  @Input() public determinantMapById: { [key: string]: string } = {};
  @Input() public showSystemBots: boolean = true; // not visible for bot-roles
  @Output() public showDeterminantModal = new EventEmitter();

  public serviceBots: Bot[] = [];
  public componentKey: string;
  public componentActionId: string;
  public componentAction: ComponentAction = new ComponentAction();

  constructor(public botService: BotControllerService,
              public determinantService: DeterminantControllerService,
              private route: ActivatedRoute,
              private componentActionControllerService: ComponentActionControllerService,
  ) { }

  public ngOnInit(): void {
    console.log(this.showHeader);
    this.route.queryParamMap.subscribe((queryParams) => {
      if (queryParams.get("key")) { this.componentKey = queryParams.get("key"); }
      if (queryParams.get("componentActionId")) { this.componentActionId = queryParams.get("componentActionId"); }
      if (this.fieldId) { this.componentKey = this.fieldId; }
      this.route.params.subscribe((params) => {
        this.serviceId = params.serviceId;
        this.loadFormComponentActions();
        this.loadServiceBots();
        if (!Object.keys(this.determinantMapById).length) {
          this.getServiceDeterminantKeyName();
        }
      });
    });
  }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

  private loadFormComponentActions() {
    if (this.componentActionId) {
      this.componentActionControllerService.getById(this.componentActionId).subscribe((data) => {
        this.componentAction = data ? data : new ComponentAction();
      });
    } else if (this.serviceId && this.componentKey) {
      this.componentActionControllerService.getComponentAction(this.serviceId, this.componentKey).subscribe(
        (data) => {
          this.componentAction = data ? data : new ComponentAction();
        },
      );
    } else {
      this.componentAction = new ComponentAction();
    }
  }

  public loadServiceBots() {
    if (this.serviceId) {
      this.botService.getAllBots(this.serviceId, this.componentKey, this.showSystemBots).subscribe(
        (data) => {
          data = _.sortBy(data, [(d) => d.name.toLowerCase()], ["asc"]);
          this.serviceBots = data.filter((b) => b.botType === "data")
              .concat(data.filter((b) => b.botType === "internal"))
              .concat(data.filter((b) => b.botType === "document"))
              .concat(data.filter((b) => b.botType === "message"))
              .concat(data.filter((b) => b.botType === "system"));
        },
      );
    }
  }

}
